<template>
  <div class="article-item">
    <div class="left-side">
      <div class="title text-line-2">{{ item.title }}</div>
      <div class="info">
        <div class="time">{{ item.updateTime.split(" ")[0] }}</div>
        <div>阅读{{ item.clickSum }}</div>
      </div>
    </div>
    <div class="right-side">
      <van-image
        width="120px"
        height="70px"
        fit="cover"
        style="border-radius: 2px"
        :src="item.coverPictureUrl"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleItem",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.article-item {
  display: flex;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 15px;

  .left-side {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    margin-right: 10px;

    .title {
      color: #111;
      font-size: 16px;
    }

    .info {
      display: flex;
      align-items: center;
      color: #00000073;

      .time {
        margin-right: 10px;
      }
    }
  }

  .right-side {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
}
</style>
